// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3bHMS","left":"StickyBox_left__3FogQ","right":"StickyBox_right__YUWmP"};